import { connect, MapStateToProps } from 'react-redux';
import { Props } from './GroupsList';
import {
  getGroupsStream,
  getRecommendedGroupsStream,
  getHasNoGroups,
} from '../../redux/selectors';
import { AddToGroupsPanelStoreSlice } from '../../redux/types';
import { flagEnabled } from '@wix/da-react-context/pkg/flags/redux/selectors';

type StateProps = Pick<
  Props,
  'streamId' | 'groups' | 'isFetching' | 'isRecommendedGroupsEnabled' | 'hasMore'
>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AddToGroupsPanelStoreSlice
> = state => {
  const hasNoGroups = getHasNoGroups(state);
  const isRecommendedGroupsEnabled = flagEnabled(state, 'recommended_groups');
  const streamData =
    hasNoGroups && isRecommendedGroupsEnabled
      ? getRecommendedGroupsStream(state)
      : getGroupsStream(state);
  return {
    ...streamData,
    isRecommendedGroupsEnabled,
  };
};

export default connect(mapStateToProps);
